import { render } from "./CountriesSection.vue?vue&type=template&id=d2114c02&scoped=true"
import script from "./CountriesSection.vue?vue&type=script&lang=js"
export * from "./CountriesSection.vue?vue&type=script&lang=js"

import "./CountriesSection.vue?vue&type=style&index=0&id=d2114c02&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2114c02"]])

export default __exports__